import {
    LayoutDashboard,
    Gamepad2,
    Trophy,
    Calendar,
    MapPin,
    CalendarCheck,
    Users,
    UserCheck,
    Crown,
    Gift,
    Wallet,
    CreditCard,
    Award,
    FileText,
    Newspaper,
    Heart,
    Package,
    Settings,
    Globe,
    Bell,
    FolderKanban,
    Image,
    BarChart3,
    ShieldCheck,
    LucideIcon,
} from 'lucide-react';

export interface SidebarItemConfig {
    id: string;
    label: string;
    icon?: LucideIcon;
    path: string;
    superAdminOnly?: boolean;
    badgeCount?: number | undefined;
}

export interface SidebarGroupConfig {
    id: string;
    label: string;
    icon: LucideIcon;
    type: 'group';
    items: SidebarItemConfig[];
}

export type SidebarConfigItem = (SidebarItemConfig & { type: 'item' }) | SidebarGroupConfig;

export const sidebarConfig: SidebarConfigItem[] = [
    {
        id: 'dashboard',
        label: 'Dashboard',
        icon: LayoutDashboard,
        path: '/admin',
        type: 'item',
    },
    {
        id: 'analytics',
        label: 'Analytics',
        icon: BarChart3,
        path: '/admin/analytics',
        type: 'item',
    },
    {
        id: 'appointments',
        label: 'Appointments',
        icon: CalendarCheck,
        path: '/admin/appointments',
        type: 'item',
    },
    {
        id: 'bookings',
        label: 'Bookings',
        icon: CalendarCheck,
        path: '/admin/bookings',
        type: 'item',
    },
    {
        id: 'operations',
        label: 'Operations',
        icon: Gamepad2,
        type: 'group',
        items: [
            { id: 'leagues', label: 'Leagues', icon: Trophy, path: '/admin/leagues' },
            { id: 'events', label: 'Events', icon: Calendar, path: '/admin/events' },
        ],
    },
    {
        id: 'organizer-management',
        label: 'Organizer Management',
        icon: UserCheck,
        type: 'group',
        items: [
            { id: 'organizers', label: 'Organizers', icon: Users, path: '/admin/organizer-management' },
            { id: 'organizer-games', label: 'Games', icon: Gamepad2, path: '/admin/games' },
            { id: 'organizer-free-games', label: 'Free Games', icon: Trophy, path: '/admin/free-games' },
            { id: 'organizer-game-approvals', label: 'Game Approvals', icon: ShieldCheck, path: '/admin/game-approvals' },
            { id: 'organizer-pitches', label: 'Pitches', icon: MapPin, path: '/admin/pitches' },
            { id: 'organizer-pitch-approvals', label: 'Pitch Approvals', icon: ShieldCheck, path: '/admin/pitch-approvals' },
            { id: 'organizer-payouts', label: 'Game Payouts', icon: Wallet, path: '/admin/game-payouts' },
        ],
    },
    {
        id: 'users',
        label: 'Users',
        icon: Users,
        type: 'group',
        items: [
            { id: 'all-users', label: 'All Users', icon: Users, path: '/admin/users' },
            { id: 'saca-pro', label: 'Saca Pro', icon: Crown, path: '/admin/saca-pro' },
            { id: 'referrals', label: 'Referrals', icon: Gift, path: '/admin/referrals' },
        ],
    },
    {
        id: 'finance',
        label: 'Finance',
        icon: Wallet,
        type: 'group',
        items: [
            { id: 'transactions', label: 'Transactions', icon: CreditCard, path: '/admin/transactions' },
            { id: 'plans', label: 'Plans', icon: CreditCard, path: '/admin/plans' },
            { id: 'referral-rewards', label: 'Referral Rewards', icon: Award, path: '/admin/referral-rewards', superAdminOnly: true },
        ],
    },
    {
        id: 'content',
        label: 'Content',
        icon: FileText,
        type: 'group',
        items: [
            { id: 'blogs', label: 'Blog', icon: Newspaper, path: '/admin/blogs' },
            { id: 'charity', label: 'Charity', icon: Heart, path: '/admin/charity' },
            { id: 'equipment', label: 'Equipment', icon: Package, path: '/admin/equipment' },
            { id: 'teams', label: 'Teams', icon: Users, path: '/admin/teams' },
            { id: 'media', label: 'Media Library', icon: Image, path: '/admin/media' },
        ],
    },
    {
        id: 'settings',
        label: 'Settings',
        icon: Settings,
        type: 'group',
        items: [
            { id: 'app-settings', label: 'App Settings', icon: Settings, path: '/admin/settings' },
            { id: 'locations', label: 'Locations', icon: Globe, path: '/admin/locations' },
            { id: 'notifications', label: 'Notifications', icon: Bell, path: '/admin/notifications' },
            { id: 'projects', label: 'Projects', icon: FolderKanban, path: '/admin/projects' },
            { id: 'email-templates', label: 'Email Templates', icon: FileText, path: '/admin/email-templates' },
            { id: 'audit-logs', label: 'Audit Logs', icon: FileText, path: '/admin/audit-logs' },
            { id: 'shop-orders', label: 'Shop Orders', icon: Package, path: '/admin/orders' },
        ],
    },
];

export default sidebarConfig;
